module.exports = __webpack_public_path__ + "static/img/6.ce96c093.png";